import { useEffect } from 'react'
import { Outlet, useParams } from 'react-router'
import { useAuth } from '@/hooks/useAuth'
import { primeTenantSlug, useRole } from '@/hooks/useRole'
import { BrandingProvider } from '@/contexts/BrandingContext'
import { FullPageSpinner } from '@/components/Spinner'

export function TenantLayout() {
  const { tenant } = useParams<{ tenant: string }>()
  const { authState } = useAuth()
  const { status, branding } = useRole()

  // Prime the singleton with the slug from the URL before any API call fires.
  useEffect(() => {
    if (tenant) primeTenantSlug(tenant)
  }, [tenant])

  // No login redirect here: a signed-out visitor is a legitimate guest — the
  // slug entry (TenantChat) shows the anonymous booking view with a sign-in
  // option, mirroring the widget workflow (guest OR signed-in).

  if (authState.status === 'loading' || status === 'loading') {
    return <FullPageSpinner color={branding?.primaryColor ?? '#3b82f6'} />
  }

  return (
    <BrandingProvider branding={branding}>
      <Outlet />
    </BrandingProvider>
  )
}
